import api from "../../../api/index";

export function orderDetails(caseId){
    return api.get(`allOrderDetails/${caseId}`);
}